export const WebsocketMethodType = {
    Message: 'Message',
    ForceRefreshToken: 'ForceRefreshToken',
    ForceLogout: 'ForceLogout',
};
